import { Component, OnInit } from '@angular/core';
import { Field } from '../../models/field.interface';
import { FieldConfig } from '../../models/field-config.interface';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatLabel, MatInput, MatError } from '@angular/material/input';
import { NgClass } from '@angular/common';
import { IosMinusButtonDirective } from '../../../directives/ios-minus-button.directive';


@Component({
    selector: 'app-form-number',
    templateUrl: './form-number.component.html',
    styleUrls: ['./form-number.component.css'],
    imports: [ReactiveFormsModule, MatFormField, NgClass, MatLabel, MatInput, IosMinusButtonDirective, MatError]
})
export class FormNumberComponent implements OnInit, Field {
  public FormControlName;
  config: FieldConfig;
  group: FormGroup;

  constructor() { }

  ngOnInit() {
    this.FormControlName = this.config.name;
  }

}
